import React from 'react';
import { FormControl, FormHelperText, FormLabel, RadioGroup } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { noop } from 'lodash';
import cn from 'classnames';

const useStyles = makeStyles(theme => ({
    root: {},
    label: {},
    radioGroup: {
        flexDirection: 'row',
    },
    helperText: {},
}));

export default function RadioGroupDyl({
    children,
    label = '',
    error = false,
    helperText = '',
    value = '',
    onChange = noop,

    classes: propsClasses,
    className: propsClass,
    ...other
}) {
    const classes = useStyles({ classes: propsClasses });

    return (
        <FormControl className={cn(classes.root, propsClass)} {...other}>
            <FormLabel
                className={classes.label}
                error={error}
            >
                {label}
            </FormLabel>

            <RadioGroup
                className={classes.radioGroup}
                value={value}
                onChange={onChange}
            >
                {children}
            </RadioGroup>

            <FormHelperText
                className={classes.helperText}
                error={error}
            >
                {helperText}
            </FormHelperText>
        </FormControl>
    );
}